/**
 * The page is imported from **its own module**, not from the `@pages` barrel.
 *
 * The barrel re-exports every page, so a route importing it pulls all of them into one shared chunk
 * that the entry then preloads — code-splitting by route, defeated by one import.
 */
import { createFileRoute } from '@tanstack/react-router';

import { ContractsPage } from '@pages/contracts';
import { IamService } from '@units/iam';

/**
 * `/contracts` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * Contract analysis against the playbooks.
 *
 * The screen behind it is a placeholder today, and the guard is not: somebody without
 * `contract:read` is stopped here, before anything renders, exactly as they will be once the real
 * screen replaces the placeholder. Little about this file changes when it does — the search schema
 * and the loader arrive, the guard stays.
 */
export const Route = createFileRoute('/_authenticated/contracts')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'contract:read',
    // The section is in the navigation of everybody who holds the right to it, so its existence is
    // no secret inside the organization and the refusal may name what is missing. The documents
    // *inside* it are the closed contour, and answer 404 (`rules/permissions.mdc`).
    whenDenied: 'forbidden',
  }),
  component: ContractsPage,
  staticData: { crumbKey: 'nav.contracts' },
});
